module.exports = __webpack_public_path__ + "static/media/logo.d4498cb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/biznisnet2020/resources/logo.png
// module id = 471
// module chunks = 0